import React from "react";

const HeroBanner: React.FC = () => {
    // Get today's date formatted as "DD Mon"
    const today = new Date();
    const day = today.getDate();
    const month = today.toLocaleDateString("en-US", { month: "short" });
    const bookByDate = `${day} ${month}`;

    return (
        <div className="relative max-h-[650px] h-[650px] w-full overflow-hidden">
            {/* Background image */}
            <div
                className="absolute inset-0 bg-cover bg-center bg-no-repeat"
                style={{
                    backgroundImage: `url('https://components.flysas.com/content/assets/ctfassets/oz9qk43ly6yk/2Q8aFhMuZEo82w5ELxSWPv/6062cb56bf16a18af4845729eec526b4/08-business-seat-038-final-sas.jpg?fm=webp&q=82&f=&w=1600')`,
                }}
            >
                {/* Optional overlay for better text contrast */}
                <div className="absolute inset-0 bg-black opacity-10"></div>
            </div>

            {/* Content overlay */}
            <div className="absolute bottom-60 right-0 left-0 px-28">
                <div className="flex justify-end">
                    <div className="bg-sas-blue text-white p-8 rounded-xl shadow-xl max-w-lg text-4xl font-medium">
                        <h1>Extra comfort for less –</h1>
                        <h1>special fares on</h1>
                        <h1 className="mb-6">Premium and Business</h1>
                        <button className="bg-transparent text-white border-2 border-white px-8 py-2 rounded-full hover:bg-white hover:text-black transition-all font-semibold text-base">
                            Book by {bookByDate}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeroBanner;
